import { gql } from '@apollo/client'

export const GET_LEAGUE_EVENTS = gql`
  query GetLeagueEvents($fantasyLeagueId: ID!, $limit: Int, $offset: Int) {
    fantasyLeagueEvents(
      fantasyLeagueId: $fantasyLeagueId
      limit: $limit
      offset: $offset
    ) {
      id
      type
      createdAt
      price
      releaseClause
      fantasyLeagueMember {
        id
        teamName
      }
      player {
        id
        nick
        role
        team {
          id
          nameShow
          shortName
          shield
        }
      }
      fantasyTeamFrom {
        id
        teamName
      }
      fantasyTeamTo {
        id
        teamName
      }
    }
  }
`
